/*global VeloxViewController, VeloxWebView*/
 
var uuid = require("uuid") ;

var reportController = new VeloxViewController({
    directory : "views/diag",
    name: "report",
    route: "report"
}) ;

module.exports = reportController ;


reportController.prepareDataOnEnter = function(data, callback){
    if(!data){ data = {} ;}
    data.canPrint = window.native && window.native.pdf && window.native.pdf.genAndPrintReport;
    callback(null, data) ;
} ;

reportController.onBeforeRender = function(){
    if(this.data.diag && this.data.diag.d_pool_or_spa === "POOL"){
        document.getElementById("main").className = document.getElementById("main").className.replace(" spa", "") ;
    }else if(this.data.diag && this.data.diag.d_pool_or_spa === "SPA"){
        if(document.getElementById("main").className.indexOf("spa") === -1){
            document.getElementById("main").className += " spa" ;
        }
    }
};

reportController.onReturn = function(){
    if(this.data.diag){
        this.data.diag.customProducts = this.view.getCustomProducts().map(function(p){
            return {
                dcp_product_name : p
            } ;
        }) ;
        this.data.diag.d_sta_council = this.view.getStaCouncil();
        this.data.diag.d_temp_council = this.view.getTemp2Council();
    }
    this.navigate("..") ;
} ;

reportController.updateDiag = function(diag, records){
    if(!diag.d_id){
        diag.d_id = uuid.v4() ;
    }
    diag.d_sta_council = this.view.getStaCouncil();
    diag.d_temp_council = this.view.getTemp2Council();
    var customProducts = this.view.getCustomProducts() ;
    records.push( { 
        table: "diag_custom_product",
        action: "removeWhere",
        record: {
            d_id: diag.d_id
        }
    });
    if(customProducts){
        customProducts.forEach(function(p){
            records.push( { 
                table: "diag_custom_product",
                action: "insert",
                record: {
                    dcp_id: uuid.v4(),
                    d_id: diag.d_id,
                    dcp_product_name: p
                }
            });
        });
    }
};

reportController.updateExtrabat = function(diag, customer, records){
    if(!customer || !customer.c_id_extrabat){
        return ;
    }
    
    records.push( { 
        table: "extrabat_diag",
        record: {
            e_code: diag.d_id,
            d_id: diag.d_id,
            r_code: customer.r_code,
            e_id: customer.c_id_extrabat,
            e_status: "todo"
        }
    });
};

var DEFAULT_PRINT_OPTIONS = {
    pdf : { 
        results   : true, details : true, shoppingList : true,
        general   : true, notes   : true, filterMaint  : true,
        cleanLine : true, startUp : true, wintering    : true, mark : true
    },
    email : { 
        results   : true, details : true, shoppingList : true,
        general   : true, notes   : true, filterMaint  : true,
        cleanLine : true, startUp : true, wintering    : true, mark : true
    },
    print : { 
        results   : true, details : true, shoppingList : true,
        general   : true, notes   : true, filterMaint  : true,
        cleanLine : true, startUp : true, wintering    : true, mark : true
    }
} ;

reportController.openPrintPopup = function(type, callback){
    //open popup
    this.api.api.velox_map.searchFirst({ code: "printOptions", key: type}, function(err, printOptions){
        if(err){ return callback(err) ;}
        this.data.printOptions = printOptions?printOptions.value : JSON.parse(JSON.stringify(DEFAULT_PRINT_OPTIONS[type]));
        this.data.printOptions.keepAsDefault = false;
        var viewPrintOptions = new VeloxWebView("views/diag", "popupPrint", {bindObject: this.data}) ;
        viewPrintOptions.openInPopup({
            size:"medium",
            title: VeloxWebView.tr("report.chooseBlock"+type)
        })  ;
    
        /**
         * User validate creation of a new user
         */
        viewPrintOptions.on("validate",function(){
            viewPrintOptions.updateData() ;
            viewPrintOptions.close() ;
            if(this.data.printOptions.keepAsDefault){
                var record = printOptions||{code: "printOptions", key:type };
                record.value = this.data.printOptions;
                this.api.api.transactionalChanges([{table : "velox_map", record: record}], callback) ;
            }else{
                callback();
            }
        }.bind(this)) ;
    }.bind(this)) ;
} ;

reportController.getHtmlToPrint = function(){
    var html = this.data.reportHTML.replace(/templates\/html\/assets\//g, "") ;

    let customizedBlocks = ["STA_1", "STA_2", "TEMP_2"] ;
    for(let blockId of customizedBlocks){
        let htmlBlock = this.view.getBlockById(blockId) ;
        if(htmlBlock){
            let indexBlock = html.indexOf(`<div class="block" id="${blockId}">`) ;
            if(indexBlock !== -1){
                let indexEnd= html.indexOf(`<div class="product">`, indexBlock) ;
                if(indexEnd !== -1){
                    html = html.substring(0, indexBlock)+`<div class="block" id="${blockId}">
<div class="textcontent">${htmlBlock}</div>`+html.substring(indexEnd) ;
                }
            }
        }
    }


    if(!this.data.printOptions.results){
        html = html.replace("#analyzeResults { display: block }", "#analyzeResults { display: none }");
    }
    if(!this.data.printOptions.details){
        html = html.replace("#analyzeDetails { display: block }", "#analyzeDetails { display: none }");
        /*if(this.data.printOptions.shoppingList){
            html = html.replace("#SHOPPING_LIST { display: block }", "#SHOPPING_LIST { width: 100% !important }");    
            html = html.replace(".product {  }", ".product {  width: 100% !important }");
            html = html.replace(".MANY .text {}", ".MANY .text { width: auto !important; float: left !important}");
        }*/
    }
    let printShopping = this.data.printOptions.shoppingList ;
    if(this.view.getCustomProducts().length === 0){
        printShopping = false;
    }
    if(!printShopping){
        html = html.replace("#SHOPPING_LIST { display: block }", "#SHOPPING_LIST { display: none }");
        /*html = html.replace(".product {  }", ".product { display: none !important }");
        if(this.data.printOptions.details){
            html = html.replace("#analyzeDetails .textcontent {  }", "#analyzeDetails .textcontent { width: calc(100% - 30px); border-right: 0 }");
            html = html.replace("#problemsDetails .textcontent {  }", "#problemsDetails .textcontent { width: calc(100% - 30px); border-right: 0 }");
        }*/
    }else{
        html = html.replace('<div id="customProductsLabel">', '<div id="customProductsLabel" style="display: block">');
        html = html.replace(/<div id="customProducts">[^<]*<\/div>/, `<div id="customProducts">${this.view.getCustomProducts().map(p=>{
            return '<div class="productEntry"><button class="removeProduct no-print">X</button><div>'+p+'</div></div>'
        })}</div>`) ;
    }
    if(!this.data.printOptions.general){
        html = html.replace("#recoGeneral { display: block }", "#recoGeneral { display: none }");
    }
    if(!this.data.printOptions.notes){
        html = html.replace("#dealerNote { display: block }", "#dealerNote { display: none }");
    }

    if(!this.data.printOptions.filterMaint){
        html = html.replace("#FILT_5 { display: block }", "#FILT_5 { display: none }");
    }

    if(!this.data.printOptions.cleanLine){
        html = html.replace("#LIGN_2 { display: block }", "#LIGN_2 { display: none }");
    }

    if(!this.data.printOptions.startUp){
        html = html.replace("#MIS_1 { display: block }", "#MIS_1 { display: none }");
    }

    if(!this.data.printOptions.wintering){
        html = html.replace("#HIV_1 { display: block }", "#HIV_1 { display: none }");
    }

    if(!this.data.printOptions.mark){
        html = html.replace("#TACH_1 { display: block }", "#TACH_1 { display: none }");
    }

    var hasReco = (
        (this.data.diag.d_startup && this.data.printOptions.startUp) ||
        (this.data.diag.d_wintering && this.data.printOptions.wintering) ||
        (this.data.diag.d_filter_maint && this.data.printOptions.filterMaint) ||
        (this.data.diag.d_clean_line && this.data.printOptions.cleanLine) ||
        (this.data.diag.d_marks && this.data.printOptions.mark)
    ) ;

    if(!hasReco){
        html = html.replace(".HAS_RECO {}", ".HAS_RECO { display: none}");
    }

    return html;
} ;

reportController.onPdf = function(){
    this.openPrintPopup("pdf", function(){
        this.view.longTask(function(done){
            var filename = VeloxWebView.tr("welcome.diag") ;
            if(this.data.diag.customer){
                filename += " - "+this.data.diag.customer.c_name ;
            }
            filename += ".pdf" ;

            var isIos = false;
            var nP = navigator.platform;      
            if (nP == "iPad" || nP == "iPhone" || nP == "iPod" || nP == "iPhone Simulator" || nP == "iPad Simulator"){
                isIos = true;
            }
            if(isIos){
                this.api.pdf.gen2(filename, this.getHtmlToPrint(), VeloxWebView.i18n.getLang(), (err, response)=>{
                    if(err){ return done(err) ; }
                    window.native.openFile(filename, response, "application/pdf") ;
                    done();
                }) ;
            }else if(window.native){
                //desktop native
                window.native.pdf.genAndOpenReport({html: this.getHtmlToPrint(), filename:filename, lang: VeloxWebView.i18n.getLang()}, done) ;
            }else{
                this.api.pdf.gen(filename, this.getHtmlToPrint(), VeloxWebView.i18n.getLang(), done) ;
            }
        }.bind(this)) ;
    }.bind(this)) ;
};
reportController.onPrint = function(){
    this.openPrintPopup("print", function(){
        if(window.native){
            this.view.longTask(function(done){ 
                this.api.api.reseller_settings.searchFirst({}, function(err, settings){
                    if(err){ return done(err) ;}

                    window.native.pdf.genAndPrintReport({html: this.getHtmlToPrint(), grayscale: settings?!settings.rs_print_color:false ,lang: VeloxWebView.i18n.getLang()}, done) ;
                }.bind(this));
            }.bind(this)) ;
        }
    }.bind(this)) ;
};
reportController.onSendEmail = function(){
    var viewEmail = new VeloxWebView("views/diag", "popupEmail", {bindObject: this.data.diag.customer}) ;
    viewEmail.openInPopup({
        size:"medium",
        title: " "
    })  ;

    /**
     * User validate creation of a new user
     */
    viewEmail.on("validate",function(){
        var email = viewEmail.getData().c_email ;
        viewEmail.close() ;
        this.openPrintPopup("pdf", function(){
            this.view.longTask(function(done){
                this.api.api.multiread({
                    reseller: { searchFirst: {r_code: this.api.currentReseller}},
                    reseller_settings: { searchFirst: {}}
                }, function(err, reads){
                    if(err){ return done(err) ;}
                    var options = reads.reseller_settings || {} ;
                    if(!options.rs_email){
                        return done(VeloxWebView.tr("report.pleaseConfigureEmail")) ;
                    }
                    var customer = { name : "", firstName : ""} ;
                    if(this.data.diag.customer){
                        customer.name = this.data.diag.customer.c_name;
                        customer.firstName = this.data.diag.customer.c_first_name;
                    }
        
                    var from = options.rs_shop_name+" <"+options.rs_email+">";
                    var html = this.getHtmlToPrint();
                    var subject = VeloxWebView.tr("report.subjectMail") ;
                    var text = VeloxWebView.tr("report.bodyMail",
                        {name : customer.name, firstName : customer.firstName, licname : options.rs_shop_name, licinfo :  options.rs_textbox, interpolation: { escapeValue: false } }) ;
                    var htmlMail = VeloxWebView.tr("report.bodyMailHTML",
                        {name : customer.name, firstName : customer.firstName, licname : options.rs_shop_name, licinfo :  options.rs_textbox, interpolation: { escapeValue: false } }) ;

                    if(reads.reseller && reads.reseller.r_nosync && window.native && window.native.localMail){
                        //no sync mail send
                        window.native.localMail.sendEmail({
                            from : from,
                            to : email,
                            subject: subject,
                            bodyPlain: text,
                            bodyHTML: htmlMail,
                            reportHTML: html,
                            lang: VeloxWebView.i18n.getLang(),
                            filenameReport: VeloxWebView.tr("report.mailFilename"),
                        }, function(err){
                            if(err){ return done(err) ;}
                            VeloxWebView.info(VeloxWebView.tr("report.confirmMailSent")) ;
                            done() ;
                        }) ;
                    }else{
                        //normal mail send
                        var emailRecord = {
                            uid: uuid.v4(),
                            from_addr: from,
                            server_uid: "noreply",
                            to_addr: email,
                            subject: subject,
                            text: text,
                            html: htmlMail,
                            status: "tosend",
                            schedule_type: "now",
                            html_report: html
                        };
                        this.api.api.transactionalChanges([{table: "velox_mail", record: emailRecord}], function(err){
                            if(err){ return done(err) ;}
                            VeloxWebView.info(VeloxWebView.tr("report.confirmMailSent")) ;
                            done() ;
                        }) ;
                    }
                }.bind(this)) ;
            }.bind(this)) ;
        }.bind(this)) ;
    }.bind(this)) ;
};


reportController.onSave = function(){
    var diag = this.data.diag;
    diag.c_id = diag.customer.c_id;

    var records = [
        {table: "diag", record: diag} 
    ] ;

    this.updateDiag(diag, records) ;
    this.updateCustomerTables(diag.customer, diag, records) ;
    this.updateExtrabat(diag, diag.customer, records) ;

    this.view.longTask(function(done){
        this.api.api.transactionalChanges(records, function(err){
            if(err){return done(err) ;}
            if(diag.customer.c_id_extrabat){
                this.data.printOptions = DEFAULT_PRINT_OPTIONS.pdf ;
                this.api.saveBinary(
                    new Blob([this.getHtmlToPrint()], {type: 'text/html'}),
                    {
                    table_name: "extrabat_diag", 
                    table_uid: diag.d_id, 
                    mime_type: "text/html",
                    description : "report",
                    filename: "report.html"
                }, function(err){
                    if(err){ return done(err); }
                    done();
                    this.navigate("/customer/form", {c: diag.customer.c_id}) ;
                }.bind(this)) ;
            } else {
                done();
                this.navigate("/customer/form", {c: diag.customer.c_id}) ;
            }
        }.bind(this)) ;
    }.bind(this)) ;
} ;

reportController.onSaveNewCustomer = function(){
    //open popup
    var viewNewCustomer = new VeloxWebView("views/customer", "customerSavePopup") ;
    viewNewCustomer.openInPopup({
        size:"medium",
        title: " "
    })  ;
    var lastSearch = 0;
    viewNewCustomer.on("searchSimilar",function(ev){
        var thisSearch = ++lastSearch ;
        var name = ev.data ;
        if(!name){
            return viewNewCustomer.updateSimilars([]) ;
        }
        this.api.api.customer.search({c_name: name+"*"}, [
            { otherTable: "diag", name: "lastDiag", type: "2one", joinOrder:"d_date DESC"},
            { otherTable: "pool"},
            { otherTable: "spa"}
        ], "c_name", function(err, customers){
            if(err){
                //discard this error
            }
            if(thisSearch !== lastSearch){
                return; //a new search has been started since last search
            }

            viewNewCustomer.updateSimilars(customers) ;

        }.bind(this)) ;
    }.bind(this))  ;

    /**
     * User choose an existing customer
     */
    viewNewCustomer.on("similarChosen",function(ev){
        var diag = this.data.diag;
        var customer = ev.data;
        if(!customer){ return ;}
        diag.c_id = customer.c_id;
        
        var records = [
            {table: "diag", record: diag}
        ] ;

        this.updateDiag(diag, records) ;

        this.checkCustomerDiff(customer, diag, function(err, diffStatus){
            if(err){ return this.view.error(err) ;}
            if(diffStatus === "update"){
                //user accept to report modification on customer
                this.updateCustomerTables(customer, diag, records) ;
                this.updateExtrabat(diag, customer, records) ;
            } else if(diffStatus === "reloadCustomer"){
                //user ask to reload the diag with customer modifications
                this.navigate("/diag/form", {c: customer.c_id, keepDiag: diag}, "anonymous") ;
                viewNewCustomer.close() ;
                return;
            } else if(diffStatus === "cancel"){
                //cancel (don't use this customer)
                return;
            }
            this.view.longTask(function(done){
                this.api.api.transactionalChanges(records, function(err){
                    if(err){return done(err) ;}
                    if(diffStatus === "update" && customer.c_id_extrabat){
                        this.data.printOptions = DEFAULT_PRINT_OPTIONS.pdf ;
                        this.api.saveBinary(
                            new Blob([this.getHtmlToPrint()], {type: 'text/html'}),
                            {
                            table_name: "extrabat_diag", 
                            table_uid: diag.d_id, 
                            mime_type: "text/html",
                            description : "report",
                            filename: "report.html"
                        }, function(err){
                            if(err){ return done(err); }
                            done();
                            viewNewCustomer.close() ;
                            this.navigate("/customer/form", {c: customer.c_id}) ;
                        }.bind(this)) ;
                    } else {
                        done();
                        viewNewCustomer.close() ;
                        this.navigate("/customer/form", {c: customer.c_id}) ;
                    }
                }.bind(this)) ;
            }.bind(this)) ;
        }.bind(this)) ;
    }.bind(this))  ;

    /**
     * User validate creation of a new user
     */
    viewNewCustomer.on("validate",function(){
        this.view.longTask(function(done){
            viewNewCustomer.checkForm(function(err, checkOk){
                if(err){return done(err) ;}
                if(!checkOk){ return done() ;}
                var customer = viewNewCustomer.getData() ;
                customer.c_id = uuid.v4() ;
                var records = [];
                records.push({
                    table : "customer",
                    record : customer,
                    action: "insert"
                }) ;
                var diag = this.data.diag;
                diag.c_id = customer.c_id;
                records.push({
                    table : "diag",
                    record : diag,
                    action: "insert"
                }) ;

                this.updateDiag(diag, records) ;
                this.updateCustomerTables(customer, diag, records) ;
    
                this.api.api.transactionalChanges(records, function(err){
                    if(err){return done(err) ;}
                    done();
                    viewNewCustomer.close() ;
                    this.navigate("/customer/form", {c: customer.c_id}) ;
                }.bind(this)) ;
            }.bind(this)) ;
        }.bind(this)) ;
    }.bind(this)) ;
} ;

reportController.onBtClose = function(){
    if(this.data.mode === "VIEW"){
        return this.navigate("..") ;
    }
    this.view.question(VeloxWebView.tr("report.doYouWantToSave"),
        {size: "medium"},
        [
            {label: VeloxWebView.tr("report.yes"), code: "yes", className: "btn-outline-primary", focus: true, isDefault: true},
            {label: VeloxWebView.tr("report.no"), code: "no", className: "btn-outline-danger"},
            {label: VeloxWebView.tr("report.cancel"), code: "cancel", className: "btn-outline-secondary"}
        ], function(answer){
            if(answer === "yes"){
                this.onSaveNewCustomer();
            }else if(answer === "no"){
                this.navigate("/") ;
            }
    }.bind(this)) ;
} ;

reportController.updateCustomerTables = function(customer, diag, records){
    if(diag.d_pool_or_spa === "POOL"){
        var pool = customer.pool ;
        var action = "update";
        if(!pool && diag.p_volume){
            var action = "insert";
            pool = {
                p_id : uuid.v4(),
                c_id: customer.c_id
            } ;
        }
        Object.keys(diag).forEach(function(k){
            if(k.indexOf("p_") === 0){
                pool[k] = diag[k] ;
            }
        }) ;
        records.push({table: "pool", action : action, record: pool});
    } else {
        var spa = customer.spa ;
        var action = "update";
        if(!spa && diag.s_volume){
            var action = "insert";
            spa = {
                s_id : uuid.v4(),
                c_id: customer.c_id
            } ;
        }
        Object.keys(diag).forEach(function(k){
            if(k.indexOf("s_") === 0){
                spa[k] = diag[k] ;
            }
        }) ;
        records.push({table: "spa", action : action, record: spa});
    }
} ;

reportController.checkCustomerDiff = function(chosenCustomer, currentDiag,  callback){
    var strDiff = [];
    var fieldsPool = [ "p_volume", "p_filter", "p_extra_installation", "p_regulation", 
        "p_disinf","p_disinf_salt_rate",
        "p_electrolyzer", "p_electrolyzer_other", "p_respect"] ;
    var fieldsSpa = [ "s_volume", "s_filter", "s_extra_installation", "s_regulation", 
        "s_disinf","s_disinf_salt_rate", "s_electrolyzer", "s_electrolyzer_other"] ;
    if(chosenCustomer.pool){
        fieldsPool.forEach(function(k){
                if(JSON.stringify(chosenCustomer.pool[k]||"") !== JSON.stringify(currentDiag[k]||"")){
                    strDiff.push(VeloxWebView.tr("fields.pool."+k));
                }
        }) ;
    }
    if(chosenCustomer.spa){
        fieldsSpa.forEach(function(k){
                if(JSON.stringify(chosenCustomer.spa[k]||"") !== JSON.stringify(currentDiag[k]||"")){
                    strDiff.push(VeloxWebView.tr("fields.spa."+k));
                }
        }) ;
    }

    if(strDiff.length > 0){
        this.view.question(VeloxWebView.tr("report.diagIsDiff")+" : "+strDiff.join(", "),
        {size: "medium"},
        [
            {label: VeloxWebView.tr("report.forceUpdate"), code: "forceUpdate", className: "btn-outline-primary"},
            {label: VeloxWebView.tr("report.reloadCustomer"), code: "reloadCustomer", className: "btn-outline-primary"},
            {label: VeloxWebView.tr("report.cancel"), code: "cancel", className: "btn-outline-secondary", isDefault: true}
        ], function(answer){
            if(answer === "forceUpdate"){
                return callback(null, "update");
            } else if(answer === "reloadCustomer"){
                if(chosenCustomer.pool){
                    fieldsPool.forEach(function(k){
                        currentDiag[k] = chosenCustomer.pool[k] ;
                    }) ;
                }
                if(chosenCustomer.spa){
                    fieldsSpa.forEach(function(k){
                        currentDiag[k] = chosenCustomer.spa[k] ;
                    }) ;
                }
                currentDiag.customer = chosenCustomer;
                return callback(null, "reloadCustomer");
            } else if(answer === "cancel"){
                return callback(null, "cancel");
            }
        }.bind(this)) ;
    } else {
        return callback(null, "update");
    }
} ;

